module.exports = __webpack_public_path__ + "img/icon_aside_ppt6_active.8312e917.svg";